module.exports = __webpack_public_path__ + "static/media/07_MINS-2.3-EC-10 1.b64e3bd2.svg";